import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
//import { environment } from '../../../../../apps/rslweb-portal/src/environments/environment';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '@rslweb/app-config';

@Injectable({
  providedIn: 'root',
})
export class MasterDataService {
  readonly #http = inject(HttpClient);
  readonly #appConfig = inject(APP_CONFIG);
  
  private url = this.#appConfig.apiUrl;

  public getMouldTypes(): Observable<any> {
    return this.#http.get(`${this.url}users/getDelivaryCost`);
  }

  public getCurrencySymbol(currencyId: number): string {
    const id = Math.floor(currencyId);
    switch (id) {
      case 1: return 'Rs';
      case 2: return '$';
      case 3: return '€';
      case 4: return '£';
      case 5: return '¥';
      default: return 'Rs';
    }
  }

  public getCurrencyLabel(currencyId: number): string {
    const id = Math.floor(currencyId);
    switch (id) {
      case 1: return 'Rs';
      case 2: return 'USD';
      case 3: return 'EUR';
      case 4: return 'GBP';
      case 5: return 'CNY';
      default: return 'Rs';
    }
  }
}
